import DrawerSection from "./sections/Drawer";
import MapSection from "./sections/Map";
import { Layout, ConfigProvider } from "antd";
import styled, { createGlobalStyle } from "styled-components";
import { useEffect, useState } from "react";

// Global styles for colors, font, etc.
const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'veterantypewriter';
    src: url('fonts/veterantypewriter.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

const AppLayout = styled(Layout)`
  position: relative;
  height: 100vh;
  width: 100%;
`;

function App() {
  const [uiHidden, setUiHidden] = useState(false);

  useEffect(() => {
    document.title = "Crime Stalkers";
  }, []);

  useEffect(() => {
    (window as any).toggleUI = () => setUiHidden((v) => !v);
    return () => {
      delete (window as any).toggleUI;
    };
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "veterantypewriter, Arial, sans-serif",
        },
      }}
    >
      <GlobalStyle />
      <AppLayout>
        <DrawerSection hidden={uiHidden} />
        <MapSection hidden={uiHidden} />
      </AppLayout>
    </ConfigProvider>
  );
}

export default App;
